import { ActionType, IProfileData, LoginShopifyUserPayload } from "./model";

import createReducer from "../createReducer";
import { Action, Nullable } from "../model";

export interface IAuthReducer {
  isAuthenticated: boolean;
  isAccountLinked: boolean;
  profile: Nullable<IProfileData>;
  otpReference: string;
  shopify_user: Nullable<any>;
  scan_hash: string | null;
}

const defaultState: IAuthReducer = {
  isAuthenticated: false,
  isAccountLinked: true,
  profile: null,
  otpReference: "",
  shopify_user: null,
  scan_hash: null,
}

export const authReducer = createReducer<IAuthReducer>(defaultState, {
  [ActionType.SET_AUTH]: (
    state: Nullable<IAuthReducer>,
    action: Action<Nullable<any>>
  ) => ({
    ...state,
    isAuthenticated: action.payload,
  }),

  [ActionType.SET_OTP_CODE]: (
    state: Nullable<IAuthReducer>,
    action: Action<Nullable<string>>
  ) => ({
    ...state,
    otpReference: action.payload,
  }),

  [ActionType.SET_PROFILE]: (
    state: Nullable<IAuthReducer>,
    action: Action<Nullable<any>>
  ) => ({
    ...state,
    profile: action.payload,
  }),

  [ActionType.SET_SHOPIFY_USER]: (
    state: Nullable<IAuthReducer>,
    action: Action<Nullable<any>>
  ) => ({
    ...state,
    shopify_user: action.payload.shopify_user,
  }),

  [ActionType.SET_ACCOUNT_LINK]: (
    state: Nullable<IAuthReducer>,
    action: Action<Nullable<any>>
  ) => ({
    ...state,
    isAccountLinked: action.payload.linked,
  }),

  [ActionType.SET_SCAN_HASH]: (
    state: Nullable<IAuthReducer>,
    action: Action<IAuthReducer["scan_hash"]>
  ) => ({
    ...state,
    scan_hash: action.payload,
  }),
  [ActionType.LOGIN_SHOPIFY_USER]: (
    state: Nullable<IAuthReducer>,
    action: Action<LoginShopifyUserPayload>
  ) => ({
    ...state,
    shopify_token: action.payload.shopify_token,
  }),
});
